import React, {useEffect} from 'react';
import type {Agent, AgentWorkSummary} from 'services/agent/types';
import {useLocalization} from 'localization';
import {Table} from 'schema';
import {useColumnConfigState} from 'schema/table/hooks/useColumnConfigState';
import {agentWorkSummaryTableConfig} from 'schemas';
import {agentWorkSummarySchema} from 'schemas/schemas/agentWorkSummarySchema';
import {useAgentWorks} from '../hooks';

type Props = {
  agent: Pick<Agent, 'id' | 'roles' | 'agentType'> | undefined;
  onRowClick?: (row: AgentWorkSummary) => void;
};

export const AgentWorksTable: React.FC<Props> = ({agent, onRowClick}) => {
  const {t} = useLocalization();

  const {
    paginationModel,
    resetPaginationModel,
    sortingConfig,
    setSortingConfig,
  } = useColumnConfigState(agentWorkSummarySchema.name);

  const {data, isLoading, total} = useAgentWorks(
    agent,
    paginationModel.page,
    paginationModel.pageSize,
    sortingConfig?.field,
    sortingConfig?.sort,
    !!agent?.id,
  );

  // Reset state on load
  useEffect(() => {
    if (paginationModel.page !== 0) {
      resetPaginationModel();
    }
    if (sortingConfig) {
      setSortingConfig(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Table
      header={t('data.header.relations')}
      schema={agentWorkSummarySchema}
      loading={isLoading}
      data={data}
      rowCount={total}
      configuration={agentWorkSummaryTableConfig}
      onRowClick={onRowClick}
    />
  );
};
